import { MuscleLegDiagram } from './MuscleLegDiagram';

/**
 * Renders structured article blocks from scienceContent.js
 */
export function ScienceArticleBody({ blocks, showMuscleDiagramAfterH2 }) {
  let h2Count = 0;
  return (
    <div className="space-y-8 md:space-y-10">
      {blocks.map((block, i) => {
        if (block.type === 'h2') {
          h2Count += 1;
          const insertDiagram = showMuscleDiagramAfterH2 && h2Count === 1;
          return (
            <div key={i} className="space-y-8">
              <h2 className="font-heading text-2xl md:text-3xl font-medium tracking-[-0.02em] text-white scroll-mt-36">
                {block.text}
              </h2>
              {insertDiagram ? (
                <figure className="rounded-2xl border border-white/[0.08] bg-zinc-900/40 p-6 md:p-8 overflow-hidden">
                  <div className="grid md:grid-cols-2 gap-8 items-center">
                    <MuscleLegDiagram className="w-full max-w-[320px] mx-auto text-teal-400/90" />
                    <figcaption className="text-zinc-400 text-sm leading-relaxed">
                      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal-400/80 block mb-2">
                        Anatomy cue
                      </span>
                      Simplified quadriceps group—where many athletes feel DOMS after squats, sprints, or new mileage. Local heat,
                      cold, or contrast targets sensation and circulation; it does not “heal” fibre overnight.
                    </figcaption>
                  </div>
                </figure>
              ) : null}
            </div>
          );
        }
        if (block.type === 'h3') {
          return (
            <h3
              key={i}
              className="font-heading text-lg md:text-xl font-medium tracking-[-0.01em] text-white/95 scroll-mt-36 pt-2"
            >
              {block.text}
            </h3>
          );
        }
        if (block.type === 'p') {
          return (
            <p key={i} className="text-zinc-300 text-base md:text-lg leading-relaxed">
              {block.text}
            </p>
          );
        }
        if (block.type === 'ul') {
          const items = Array.isArray(block.items) ? block.items : [];
          return (
            <ul key={i} className="list-disc pl-6 space-y-3 text-zinc-300 text-base md:text-lg leading-relaxed marker:text-teal-500/80">
              {items.map((item, j) => (
                <li key={`${i}-${j}`}>{item}</li>
              ))}
            </ul>
          );
        }
        if (block.type === 'callout') {
          return (
            <aside
              key={i}
              className="rounded-xl border border-[#c9a962]/35 bg-[#c9a962]/[0.06] px-6 py-5 md:px-8 md:py-6"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#c9a962]/90 mb-2">{block.title}</p>
              <p className="text-zinc-200 text-sm md:text-base leading-relaxed">{block.text}</p>
            </aside>
          );
        }
        if (block.type === 'figure') {
          return (
            <figure key={i} className="space-y-3">
              <div className="rounded-2xl overflow-hidden border border-white/[0.08] ring-1 ring-white/[0.04] shadow-[0_24px_64px_-32px_rgba(0,0,0,0.8)]">
                <img
                  src={block.src}
                  alt={block.alt}
                  className="w-full h-auto object-cover max-h-[min(420px,50vh)]"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
              </div>
              {block.caption ? (
                <figcaption className="text-zinc-500 text-xs md:text-sm font-mono tracking-wide">{block.caption}</figcaption>
              ) : null}
            </figure>
          );
        }
        return null;
      })}
    </div>
  );
}
